import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import Icon from 'snippets/icon/icon'

function NoticeGlobal() {
  const [type, setType] = useState('standard')
  const [content, setContent] = useState('')
  const [classCustom, setClassCustom] = useState('')
  const [isDisplayed, setIsDisplayed] = useState(false)
  const iconClass = 'mr-2 h-4.5 w-4.5 text-inherit'
  const isError = type === 'error'

  useEffect(() => {
    globalEmitter.on(emitterProps.notice.global, (value) => {
      const { type, content, classCustom, duration = 10000 } = value

      if (type) setType(type)
      if (content) setContent(content)
      if (classCustom) setClassCustom(classCustom)

      setIsDisplayed(true)
      setTimeout(() => setIsDisplayed(false), duration)
    })
  }, [])

  return (
    isDisplayed && (
      <div
        className={`fixed bottom-6 left-1/2 flex w-fit min-w-[300px] -translate-x-1/2 items-center justify-center rounded-full border px-6 py-3 shadow-base z-50 ${
          isError ? 'border-error bg-white text-error-content' : 'border-primary-900 bg-primary-900 text-white'
        } ${classCustom}`}
      >
        <span onClick={() => isError && setIsDisplayed(false)} className={isError ? 'cursor-pointer' : ''}>
          <Icon className={iconClass} name={isError ? 'icon-faild' : 'icon-success'} viewBox="0 0 18 18" />
        </span>
        <p className="text-sm text-inherit leading-2">{content}</p>
      </div>
    )
  )
}

export default NoticeGlobal
